<div id="map" style="border: 0px solid #35b0e3; height: 50vh; max-width: 100%"></div>
